import s from "./PlayerItem.module.css";

const PlayerItem = () => {
  return (
      <div className={s.TopsPlayersBlockItem}>
          <div>123423</div>
          <div>ArtLab</div>
        <div>243 562 434</div>
      </div>
  );
};

export default PlayerItem;
